module.exports = __webpack_public_path__ + "static/media/estrella.41c4b5b0.svg";